export default __webpack_public_path__ + "static/media/ocean.aaa9616b.jpg";